'use client';

import { Board } from './board';

export default function Page() {
  return <Board />;
}
